@if (detectionSummary) {
  <div class="indicators">
    <div>
      <mat-icon matTooltip="{{ 'emergency_hight_level' | transloco }}">
        emergency_home
      </mat-icon>
      &nbsp;{{ detectionSummary.emergencyCount }}
    </div>

    <div>
      <mat-icon matTooltip="{{ 'density_peak_detection_description' | transloco }}">
        leaderboard
      </mat-icon>
      &nbsp;{{ detectionSummary.densityPeak.toFixed(0) }}
    </div>

    <div>
      <mat-icon matTooltip="{{ 'total' | transloco }}">
        stacks
      </mat-icon>
      &nbsp;{{ detectionSummary.detectionCount }}
    </div>
  </div>
}
